import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import './AddDistrict.css';

const EditMasterForm = () => {
  const { id } = useParams();
  const [formData, setFormData] = useState({
    form_name: '',
    form_description: '',
    is_active: true
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetchForm();
  }, [id]);

  const fetchForm = async () => {
    try {
      const response = await axios.get(`/api/forms/${id}`);
      setFormData({
        form_name: response.data.form_name,
        form_description: response.data.form_description || '',
        is_active: response.data.is_active
      });
    } catch (error) {
      console.error('Failed to fetch form:', error);
      setError('Failed to load form');
    }
  };

  const handleChange = (e) => {
    const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    setFormData({
      ...formData,
      [e.target.name]: value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await axios.put(`/api/forms/${id}`, formData);
      navigate('/superadmin/forms');
    } catch (error) {
      setError(error.response?.data?.error || 'Failed to update form');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="add-district">
      <h2>Edit Master Form</h2>
      {error && <div className="error-message">{error}</div>}
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Form Name *</label>
          <input
            type="text"
            name="form_name"
            value={formData.form_name}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Form Description</label>
          <textarea
            name="form_description"
            value={formData.form_description}
            onChange={handleChange}
            rows="4"
            style={{ width: '100%', padding: '0.75rem', border: '1px solid #ddd', borderRadius: '4px' }}
          />
        </div>

        <div className="form-group">
          <label>
            <input
              type="checkbox"
              name="is_active"
              checked={formData.is_active}
              onChange={handleChange}
            />
            {' '}Active
          </label>
        </div>

        <div className="form-actions">
          <button type="submit" className="btn-primary" disabled={loading}>
            {loading ? 'Updating...' : 'Update Form'}
          </button>
          <button 
            type="button" 
            className="btn-secondary" 
            onClick={() => navigate('/superadmin/forms')}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default EditMasterForm;




